import { render, staticRenderFns } from "./SortUpSolid.vue?vue&type=template&id=742e1496&scoped=true"
var script = {}
import style0 from "./SortUpSolid.vue?vue&type=style&index=0&id=742e1496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e1496",
  null
  
)

export default component.exports